import { render } from "./source-settings.vue?vue&type=template&id=6c45429b"
import script from "./source-settings.vue?vue&type=script&lang=js"
export * from "./source-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__